import React from 'react';
import CustomDropdown from './CustomDropdown';

const OrderPageDesign = ({
    selectedStair,
    handleStairModification,
    handleNameAddition,
    isTriangleDisabled,
    stairsModels,
    woodTypesTriangleStep,
    woodTypesLowercover,
    woodTypesStep,
    woodTypesPlatform,
    otherWoodTypes,
    otherSizes,
    handrail_woodTypes,
    handrailModels,
    selectedStepIndex,
    setSelectedStepIndex,
    selectedPlatformIndex,
    setSelectedPlatformIndex,
    selectedSquarePlatformIndex,
    setSelectedSquarePlatformIndex,
    selectedHandrailIndex,
    setSelectedHandrailIndex,
    selectedOtherIndex,
    setSelectedOtherIndex,
    handleDeleteItem,
    handleEditItemName,
    handleWoodObjectModification,
    handleOtherModification,
    selectedStraightSteps,
    selectedPlatform,
    selectedSquarePlatform,
    selectedHandrails,
    selectedOther,
}) => {
    
    const lowerCoverModel =
        ["Kide", "Leiju", "Valo", "Kannel", "Nori"].includes(selectedStair?.stairsModel);
    
    return(
    <div>
        <div>
            {/* Display form fields for the selected stair */}
            <div className="checkbox-field">
                <div className="form-group">
                    <label htmlFor="stairsModel">Askelmamalli:</label>
                    <select
                        className="form-input"
                        id="stairsModel"
                        name="stairsModel"
                        value={selectedStair.stairsModel}
                        onChange={handleStairModification}
                        style={{ width: "180px" }}
                        required
                    >
                        <option value=""></option>
                        {stairsModels.map((stairsModel, index) => (
                            <option key={index} value={stairsModel}>{stairsModel}</option>
                        ))}
                    </select>
                </div>
                <div className="form-group-container">
                    <div className="form-group-checkbox">

                        <input type="checkbox" id="U_stairs" name="U_stairs" checked={selectedStair?.U_stairs} onChange={handleStairModification} disabled={isTriangleDisabled} />
                        <label htmlFor="U_stairs">Kiertävä U-porras</label>
                    </div>
                    <div className="form-group-checkbox">

                        <input type="checkbox" id="L_stairs" name="L_stairs" checked={selectedStair?.L_stairs} onChange={handleStairModification} disabled={isTriangleDisabled} />
                        <label htmlFor="L_stairs">Kiertävä L-porras</label>
                    </div>
                </div>
                <div className="add-buttons">
                    <button className="gradoGreenButton" type="button" onClick={() => handleNameAddition('straightSteps')}>+ Lisää suoria</button>
                    <button className="gradoGreenButton" type="button" onClick={() => handleNameAddition('handrails')}>+ Lisää käsijohteet</button>
                </div>
                <div className="add-buttons">
                    <button className="gradoGreenButton" type="button" onClick={() => handleNameAddition('platforms')}>+ Lisää taso</button>
                    <button className="gradoGreenButton" type="button" onClick={() => handleNameAddition('squarePlatforms')}>+ Lisää neliötaso</button>
                </div>
                <div className="add-buttons">
                    <button className="gradoGreenButton" type="button" onClick={() => handleNameAddition('others')}>+ Lisää muu</button>
                </div>
            </div>
            <div className="form-columns-design">
                {(selectedStair?.L_stairs || selectedStair?.U_stairs || lowerCoverModel) && (
                <div className='form-column'>
                    {/*
                    <div className="form-group">
                        <label htmlFor="stepGroove">Liukuesteuritus:</label>
                        <input type="text" className="form-input" id="stepGroove" name="stepGroove" value={selectedStair?.stepGroove || ''} onChange={handleStairModification} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="stepColor">Askelman sävy:</label>
                        <input type="text" className="form-input" id="stepColor" name="stepColor" value={selectedStair?.stepColor || ''} onChange={handleStairModification} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="ledColor">LED sävy:</label>
                        <input type="text" className="form-input" id="ledColor" name="ledColor" value={selectedStair?.ledColor || ''} onChange={handleStairModification} />
                    </div>*/}
                    {(selectedStair?.L_stairs || selectedStair?.U_stairs) && (
                        <div className="form-group">
                            <label htmlFor="triangleWoodType">Kiertävien puulaji:</label>
                            <select
                                className="form-input"
                                id="triangleWoodType"
                                name="triangleWoodType"
                                value={selectedStair?.triangleWoodType}
                                onChange={handleStairModification}
                                style={{ width: "190px" }}
                                required
                            >
                                <option value=""></option>
                                {woodTypesTriangleStep.map((triangleWoodType, index) => (
                                    <option key={index} value={triangleWoodType}>{triangleWoodType}</option>
                                ))}
                            </select>
                        </div>
                    )}
                    {(lowerCoverModel) && (
                        <div className="form-group">
                            <label htmlFor="lowerCoverWoodType">Alakansien puulaji:</label>
                            <select
                                className="form-input"
                                id="lowerCoverWoodType"
                                name="lowerCoverWoodType"
                                value={selectedStair?.lowerCoverWoodType}
                                onChange={handleStairModification}
                                style={{ width: "190px" }}
                                required
                            >
                                <option value=""></option>
                                {woodTypesLowercover.map((lowerCoverWoodType, index) => (
                                    <option key={index} value={lowerCoverWoodType}>{lowerCoverWoodType}</option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>
                )}
                {(selectedStair.straightSteps.length > 0) && (
                    <div className="form-column">
                        {/* Dropdown to select a straight step */}
                        <div className="form-group">
                            <label htmlFor="selectedStep">Valitse suorat:</label>
                            <CustomDropdown
                                items={selectedStair.straightSteps.map((step, index) => ({ name: step.stepName, index }))}
                                selectedIndex={selectedStepIndex}
                                onChange={(index) => setSelectedStepIndex(index)}
                                onDelete={(index) => handleDeleteItem(index, 'straightSteps')}
                                onEdit={(index, newName) => handleEditItemName(index, newName, 'straightSteps')}
                            />
                        </div>

                        {/* Only show the form if a straight step is selected */}
                        {selectedStepIndex !== null && (
                            <div>
                                <div className="form-group">
                                    <label htmlFor="stepWoodType">Suorien askelmien puulaji:</label>
                                    <select
                                        className="form-input"
                                        id="stepWoodType"
                                        name="stepWoodType"
                                        value={selectedStraightSteps?.stepWoodType || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'straightSteps')}
                                        style={{ width: "180px" }}
                                    >
                                        <option value=""></option>
                                        {woodTypesStep.map((woodType, index) => (
                                            <option key={index} value={woodType}>{woodType}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="stepLength">Suorien pituus:</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="stepLength"
                                        name="stepLength"
                                        value={selectedStraightSteps?.stepLength || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'straightSteps')}
                                        pattern="[0-9]*"
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="stepDepth">Suorien syvyys:</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="stepDepth"
                                        name="stepDepth"
                                        value={selectedStraightSteps?.stepDepth || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'straightSteps')}
                                        pattern="[0-9]*"
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="stepAmount">Suorien määrä:</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="stepAmount"
                                        name="stepAmount"
                                        value={selectedStraightSteps?.stepAmount || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'straightSteps')}
                                        pattern="[0-9]*"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {(selectedStair.platforms.length > 0) && (
                    <div className="form-column">
                        {/* Dropdown to select a platform */}
                        <div className="form-group">
                            <label htmlFor="selectedPlatform">Valitse taso:</label>
                            <CustomDropdown
                                items={selectedStair.platforms.map((platform, index) => ({ name: platform.platformName, index }))}
                                selectedIndex={selectedPlatformIndex}
                                onChange={(index) => setSelectedPlatformIndex(index)}
                                onDelete={(index) => handleDeleteItem(index, 'platforms')}
                                onEdit={(index, newName) => handleEditItemName(index, newName, 'platforms')}
                            />
                        </div>

                        {/* Only show the form if a platform is selected */}
                        {selectedPlatformIndex !== null && (
                            <div>
                                <div className="form-group">
                                    <label htmlFor="platformWoodType">Tason puulaji:</label>
                                    <select
                                        className="form-input"
                                        id="platformWoodType"
                                        name="platformWoodType"
                                        value={selectedPlatform?.platformWoodType || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'platforms')}
                                        style={{ width: "180px" }}
                                    >
                                        <option value=""></option>
                                        {woodTypesPlatform.map((woodType, index) => (
                                            <option key={index} value={woodType}>{woodType}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="platformLength">Tason pituus:</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="platformLength"
                                        name="platformLength"
                                        value={selectedPlatform?.platformLength || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'platforms')}
                                        pattern="[0-9]*"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {(selectedStair.squarePlatforms.length > 0) && (
                    <div className="form-column">
                        {/* Dropdown to select a square platform */}
                        <div className="form-group">
                            <label htmlFor="selectedSquarePlatform">Valitse neliötaso:</label>
                            <CustomDropdown
                                items={selectedStair.squarePlatforms.map((squarePlatform, index) => ({ name: squarePlatform.squarePlatformName, index }))}
                                selectedIndex={selectedSquarePlatformIndex}
                                onChange={(index) => setSelectedSquarePlatformIndex(index)}
                                onDelete={(index) => handleDeleteItem(index, 'squarePlatforms')}
                                onEdit={(index, newName) => handleEditItemName(index, newName, 'squarePlatforms')}
                            />
                        </div>


                        {/* Only show the form if a square platform is selected */}
                        {selectedSquarePlatformIndex !== null && (
                            <div>
                                <div className="form-group">
                                    <label htmlFor="squarePlatformWoodType">Neliötason puulaji:</label>
                                    <select
                                        className="form-input"
                                        id="squarePlatformWoodType"
                                        name="squarePlatformWoodType"
                                        value={selectedSquarePlatform?.squarePlatformWoodType || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'squarePlatforms')}
                                        style={{ width: "180px" }}
                                    >
                                        <option value=""></option>
                                        {woodTypesPlatform.map((woodType, index) => (
                                            <option key={index} value={woodType}>{woodType}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="squarePlatformLength">Neliötason pituus:</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="squarePlatformLength"
                                        name="squarePlatformLength"
                                        value={selectedSquarePlatform?.squarePlatformLength || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'squarePlatforms')}
                                        pattern="[0-9]*"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {(selectedStair.handrails.length > 0) && (
                    <div className="form-column">
                        {/* Dropdown to select a handrail */}
                        <div className="form-group">
                            <label htmlFor="selectedHandrail">Valitse käsijohteet:</label>
                            <CustomDropdown
                                items={selectedStair.handrails.map((handrail, index) => ({ name: handrail.handrailName, index }))}
                                selectedIndex={selectedHandrailIndex}
                                onChange={(index) => setSelectedHandrailIndex(index)}
                                onDelete={(index) => handleDeleteItem(index, 'handrails')}
                                onEdit={(index, newName) => handleEditItemName(index, newName, 'handrails')}
                            />
                        </div>


                        {/* Only show the form if a handrail is selected */}
                        {selectedHandrailIndex !== null && (
                            <div>
                                <div className="form-group">
                                    <label htmlFor="handrailWoodType">Käsijohteen puulaji:</label>
                                    <select
                                        className="form-input"
                                        id="handrailWoodType"
                                        name="handrailWoodType"
                                        value={selectedHandrails?.handrailWoodType || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'handrails')}
                                        style={{ width: "180px" }}
                                    >
                                        <option value=""></option>
                                        {handrail_woodTypes.map((woodType, index) => (
                                            <option key={index} value={woodType}>{woodType}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="handrailModel">Käsijohteen malli:</label>
                                    <select
                                        className="form-input"
                                        id="handrailModel"
                                        name="handrailModel"
                                        value={selectedHandrails?.handrailModel || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'handrails')}
                                        style={{ width: "180px" }}
                                    >
                                        <option value=""></option>
                                        {handrailModels.map((model, index) => (
                                            <option key={index} value={model}>{model}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="handrailAmount">Käsijohdesalkojen määrä:</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="handrailAmount"
                                        name="handrailAmount"
                                        value={selectedHandrails?.handrailAmount || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'handrails')}
                                        pattern="[0-9]*"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {(selectedStair.others.length > 0) && (
                    <div className="form-column">
                        {/* Dropdown to select an item */}
                        <div className="form-group">
                            <label htmlFor="selectedMuu">Valitse muu:</label>
                            <CustomDropdown
                                items={selectedStair.others.map((other, index) => ({ name: other.otherName, index }))}
                                selectedIndex={selectedOtherIndex}
                                onChange={(index) => setSelectedOtherIndex(index)}
                                onDelete={(index) => handleDeleteItem(index, 'others')}
                                onEdit={(index, newName) => handleEditItemName(index, newName, 'others')}
                            />
                        </div>

                        {/* Only show the form if an item is selected */}
                        {selectedOtherIndex !== null && (
                            <div>
                                <div className="form-group">
                                    <label htmlFor="otherWoodType">Tuotteen puulaji:</label>
                                    <select
                                        className="form-input"
                                        id="otherWoodType"
                                        name="otherWoodType"
                                        value={selectedOther?.otherWoodType || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'others')}
                                        style={{ width: "180px" }}
                                    >
                                        <option value=""></option>
                                        {otherWoodTypes.map((woodType, index) => (
                                            <option key={index} value={woodType}>{woodType}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="otherLength">Valitse koko:</label>
                                    <select
                                        className="form-input"
                                        id="otherLength"
                                        name="otherLength"
                                        value={selectedOther
                                            ? `${selectedOther.otherLength}x${selectedOther.otherDepth}x${selectedOther.otherThickness}`
                                            : ''}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            const selectedItem = otherSizes.find(item =>
                                                `${item.length}x${item.depth}x${item.thickness}` === selectedValue
                                            );
                                            if (selectedItem) {
                                                handleOtherModification({
                                                    otherLength: selectedItem.length,
                                                    otherDepth: selectedItem.depth,
                                                    otherThickness: selectedItem.thickness
                                                }, 'others');
                                            }
                                        }}
                                        style={{ width: "180px" }}
                                    >
                                        <option value=""></option>
                                        {otherSizes.map((item, index) => (
                                            <option
                                                key={index}
                                                value={`${item.length}x${item.depth}x${item.thickness}`}
                                            >
                                                {`${item.length} x ${item.depth} x ${item.thickness}`}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="itemAmount">Määrä:</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="itemAmount"
                                        name="otherAmount"
                                        value={selectedOther?.otherAmount || ''}
                                        onChange={(e) => handleWoodObjectModification(e, 'others')}
                                        pattern="[0-9]*"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}

            </div>

        </div>

    </div>
)};

export default OrderPageDesign;
